export default "__VITE_ASSET__mnvl4XYY__"